var map = {
	"./award-1.svg": 8565,
	"./award-2.svg": 5825,
	"./award-3.svg": 6242,
	"./big_trophy.svg": 3713,
	"./bronze.svg": 4918,
	"./gold.svg": 6285,
	"./money_double.svg": 9105,
	"./money_singular.svg": 1485,
	"./money_triple.svg": 7863,
	"./ribbon.svg": 3999,
	"./silver.svg": 2000,
	"./sparkles-two.svg": 4849,
	"./trophy-bronze.svg": 3015,
	"./trophy-silver.svg": 4850,
	"./trophy.svg": 9257,
	"./trophy_big.svg": 7404,
	"./twomaidslogo.svg": 3933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;